// src/stores/sagas/event.js
import { takeLatest, call } from 'redux-saga/effects'
import axios from 'axios'
import moment from 'moment'
import apiConfig from '@services/apiConfig'
import errorHandler from '../errorHandler'
import {
  CREATE_EVENT_ACTION,
  GET_EVENTS_ACTION,
  DELETE_EVENT_ACTION,
  UPDATE_EVENT_ACTION,
  GET_EVENT_ACTION,
  GET_ACIVITY_ACTION,
} from '@stores/actions/event'

const parseDate = (s) => moment(s, [moment.ISO_8601, 'DD/MM/YYYY HH:mm:ss', 'YYYY-MM-DD HH:mm:ss'], true).toDate()

const serializeDate = (d) => moment(d).format('YYYY-MM-DD[T]HH:mm:ss')

const toCalendarEvent = (dto) => ({
  id: dto.id,
  title: dto.activityName,
  description: dto.description,
  start: parseDate(dto.start),
  end: parseDate(dto.end),
  activity: { id: dto.activityId, name: dto.activityName },
  room: { id: dto.roomId, title: dto.roomName },
})

const toServerDto = (event) => ({
  id: event.id || 0,
  activityId: event.activity?.id ?? event.activityId,
  roomId: event.room?.id ?? event.roomId,
  start: typeof event.start === 'string' ? event.start : serializeDate(event.start),
  end: typeof event.end === 'string' ? event.end : serializeDate(event.end),
  description: event.description || '',
  activityName: event.activity?.name ?? event.activityName ?? (
    typeof event.title === 'string' ? event.title : event.title?.name
  ) ?? '',
  roomName: event.room?.title ?? event.roomName ?? '',
  weekly: !!event.weekly,
})

function* getActivitiesWorker({ callback }) {
  try {
    const res = yield call(axios, {
      method: 'GET',
      url: `${apiConfig.prefix}/activity`,
    })
    callback && callback(res.data || [])
  } catch (err) {
    callback && callback([])
    errorHandler(err)
  }
}

function* getEventsWorker({ params, callback }) {
  try {
    const safeParams = (params && typeof params === 'object' && !Array.isArray(params)) ? params : undefined
    const url = `${apiConfig.prefix}/ActivityRoom`

    const res = yield call(axios, {
      method: 'GET',
      url,
      params: safeParams,
    })
    const list = (res.data || []).map(toCalendarEvent)
    callback && callback(list)
  } catch (err) {
    try { callback && callback([]) } catch (_) { /* empty */ }
  }
}

function* getEventWorker({ params, callback }) {
  try {
    const res = yield call(axios, {
      method: 'GET',
      url: `${apiConfig.prefix}/ActivityRoom/${params?.id}`,
    })
    const dto = res.data
    callback && callback(dto ? toCalendarEvent(dto) : null)
  } catch (err) {
    callback && callback(null)
    errorHandler(err)
  }
}

function* createEventWorker({ data, callback }) {
  try {
    const payload = toServerDto(data)
    yield call(axios, {
      method: 'POST',
      url: `${apiConfig.prefix}/ActivityRoom`,
      data: payload,
    })
    const created = { ...data, id: data.id || Date.now() }
    callback && callback(created)
  } catch (err) {
    callback && callback()
    errorHandler(err)
  }
}

function* updateEventWorker({ data, callback }) {
  try {
    const payload = toServerDto(data)
    yield call(axios, {
      method: 'PUT',
      url: `${apiConfig.prefix}/ActivityRoom`,
      data: payload,
    })
    callback && callback(data)
  } catch (err) {
    callback && callback()
    errorHandler(err)
  }
}

function* deleteEventWorker({ params, callback }) {
  try {
    const { id } = params
    yield call(axios, {
      method: 'DELETE',
      url: `${apiConfig.prefix}/ActivityRoom/${id}`,
    })
    callback && callback(true)
  } catch (err) {
    callback && callback(false)
    errorHandler(err)
  }
}

export function* getActivitySaga() { yield takeLatest(GET_ACIVITY_ACTION, getActivitiesWorker) }
export function* getEventsSaga() { yield takeLatest(GET_EVENTS_ACTION, getEventsWorker) }
export function* createEventSaga() { yield takeLatest(CREATE_EVENT_ACTION, createEventWorker) }
export function* updateEventSaga() { yield takeLatest(UPDATE_EVENT_ACTION, updateEventWorker) }
export function* deleteEventSaga() { yield takeLatest(DELETE_EVENT_ACTION, deleteEventWorker) }
export function* getEventSaga() { yield takeLatest(GET_EVENT_ACTION, getEventWorker) }
